export default __webpack_public_path__ + "static/media/motorcycle.12d50a23.png";